import styled from 'styled-components';

import {
	DropdownInput as BaseDropdownInput,
	TextInput as BaseTextInput
} from 'components/UI/Input';
import { TextLink } from 'components/UI/TextLink';
import { DESKTOP_GRID_COLUMN, DESKTOP_GRID_SPACING } from 'consts';
import { Colors, MediaQueries } from 'environment';

export const Container = styled.div`
	width: 100%;

	@media ${MediaQueries.desktop} {
		width: ${DESKTOP_GRID_COLUMN * 6 + DESKTOP_GRID_SPACING * 5}rem;
		margin-right: ${DESKTOP_GRID_SPACING}rem;
	}
`;

export const Row = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;

	@media ${MediaQueries.phone} {
		flex-direction: column;
	}
`;

export const Title = styled.h3`
	font-family: 'Open Sans';
	font-weight: 600;
	margin-bottom: 2.5rem;
`;

export const Disclaimer = styled.span`
	display: inline-block;
	margin-top: 4rem;
	margin-bottom: 8rem;

	@media ${MediaQueries.phone} {
		margin-bottom: 4rem;
	}
`;

export const Link = styled(TextLink)`
	font-size: 1.4rem;
	line-height: 2.2rem;
`;

export const BaitInput = styled(BaseTextInput)`
	opacity: 0;
	position: absolute;
	top: 0;
	left: 0;
	height: 0;
	width: 0;
	z-index: -1;
`;

export const InputWrapper = styled.div`
	width: calc(50% - 1rem);

	@media ${MediaQueries.phone} {
		width: 100%;
	}
`;

export const TextInput = styled(BaseTextInput)`
	margin-top: 4rem;
`;

export const DropdownInput = styled(BaseDropdownInput)`
	margin-top: 4rem;
`;

export const Error = styled.p`
	color: ${Colors.danger};
	font-size: 2rem;
	line-height: 2.7rem;
	font-family: 'Open Sans';
	font-weight: 600;
	margin-top: 2rem;
`;
